module.exports = __webpack_public_path__ + "img/huoyun.35517263.png";